module.exports = __webpack_public_path__ + "static/ud_prototyping_process-95f7d6dac579f82adb8deeacf93cbd39.svg";